import React, { useContext } from "react";
import InputsContext from "../contexts/InputsContext";
import { findInputs } from "../concerns/findInputs";
import RadioButtons from "../../../inputs/RadioButtons";

const RadioButtonStep = ({ stepIndex, title }) => {
  const { inputs, setInputs } = useContext(InputsContext);
  const thisStepInput = findInputs(inputs, stepIndex);

  const isValid = (event) => {
    if (event.target.value) {
      thisStepInput.inputs[0].valid = true;
    }
    thisStepInput.valid = true;
    inputs.currentIndex += 1;
    setInputs({ ...inputs });
  };

  return (
    <div
      className={`${inputs.currentIndex === stepIndex ? "block" : "hidden"}`}
    >
      <div className="text-4xl font-bold">{thisStepInput.inputs[0].label}</div>
      <RadioButtons
        buttons={thisStepInput.inputs[0].buttons}
        model={inputs.model}
        name={thisStepInput.inputs[0].name}
        isValid={isValid}
      />
    </div>
  );
};

export default RadioButtonStep;
